import { BehaviorSubject, throwError, Subject, timer } from 'rxjs';
import { GeneratorEnv } from '../../web-generator/generator-env-token';
import { HttpErrorResponse } from '@angular/common/http';
import { delay, filter, tap } from 'rxjs/operators';
import { OAuthError } from 'src/app/share/entity/OauthError';
import { parseJWTtoken } from 'src/app/util';
import * as moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "../../web-generator/generator-env-token";
import * as i2 from "@angular/router";
import * as i3 from "@techmore/global";
import * as i4 from "@ngx-translate/core";
import * as i5 from "./server-config.service";
/** 模板類型 */
export var TemplateType;
(function (TemplateType) {
    /** 首頁模板 */
    TemplateType[TemplateType["index"] = 0] = "index";
    /** 主題模板 */
    TemplateType[TemplateType["subject"] = 1] = "subject";
})(TemplateType || (TemplateType = {}));
/** 後台模板編輯服務代理 */
export class BackStageTemplateService {
    constructor(generatorEnv, route, globalComponentService, translateService, serverConfigService) {
        this.generatorEnv = generatorEnv;
        this.route = route;
        this.globalComponentService = globalComponentService;
        this.translateService = translateService;
        this.serverConfigService = serverConfigService;
        this._isRefreshing = new BehaviorSubject(false);
        // /** 提交首頁編輯模板設定 */
        // updateTemplate(): Observable<Template> {
        //   return this.templateService.updateTemplate().pipe(
        //     catchError((error, observable) => this._errorHandler<any>(error, observable)),
        //   );
        // }
        // /** 移動區塊順序 */
        // moveSection(uuid: string, direction: boolean) {
        //   this.templateService.moveSection(uuid, direction);
        // }
        this._errorHandler = (error, observableFunc) => {
            if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                    switch (error.error.subStatus) {
                        case '612':
                            // FIXME: 登入超時
                            if (!this._isRefreshing.getValue()) {
                                this._isRefreshing.next(true);
                                this.requestUpdateToken();
                            }
                            const subj = new Subject();
                            this._isRefreshing.pipe(filter(r => !r), 
                            // switchMap(r => observableFunc().pipe(delay(500))),
                            tap(v => {
                                // console.log('123');
                            })).subscribe(v => {
                                observableFunc().pipe(delay(500)).subscribe(v2 => {
                                    subj.next(v2);
                                    // subj.complete();
                                });
                            });
                            return subj;
                        case '611':
                            // 認證失效 請重新登入
                            const oauthError = Object.assign(new OAuthError(this.translateService), error.error);
                            window['tokenTimeout'] = true;
                            this.globalComponentService.openErrorAlert(oauthError.getMessage(), {
                                afterClose: () => {
                                    this.requestUpdateToken();
                                    window.close();
                                },
                                showCopyTip: true
                            });
                            break;
                        case '610':
                            // token 未經授權
                            const oauthError2 = Object.assign(new OAuthError(this.translateService), error.error);
                            window['tokenTimeout'] = true;
                            this.globalComponentService.openErrorAlert(oauthError2.getMessage(), {
                                afterClose: () => {
                                    window.close();
                                },
                            });
                            break;
                        default:
                            break;
                    }
                }
            }
            return throwError(error);
        };
    }
    listenOnWindowMessage(isIndexPage, isSubjectDetailPage) {
        if (isIndexPage) {
            this.type = TemplateType.index;
        }
        else if (isSubjectDetailPage) {
            this.type = TemplateType.subject;
        }
        const subj = new Subject();
        window.addEventListener('message', (event) => {
            const match = this.generatorEnv.allowBackStageDomain.find(domain => domain === event.origin);
            if (!match) {
                return;
            }
            const dataFromParent = event.data;
            if (dataFromParent) {
                if (this.type === TemplateType.index) { // 首頁
                    if (dataFromParent.indexEdit && dataFromParent.indexEdit.accessToken && dataFromParent.indexEdit.refreshToken) {
                        // 首頁編輯
                        sessionStorage.setItem(this.generatorEnv.accessTokenKey, dataFromParent.indexEdit.accessToken);
                        sessionStorage.setItem(this.generatorEnv.refreshTokenKey, dataFromParent.indexEdit.refreshToken);
                        this.startReadyToTimeOutTimer(dataFromParent.indexEdit.accessToken, dataFromParent.indexEdit.refreshToken);
                        subj.next(dataFromParent.indexEdit);
                        if (this._isRefreshing.value) {
                            this._isRefreshing.next(false);
                        }
                        if (!this.serverConfigService.isEditModeUrl) {
                            this.serverConfigService.isEditModeUrl = true;
                        }
                    }
                    else if (dataFromParent === 'close') {
                        window.close();
                    }
                    else if (dataFromParent === 'timeoutRefreshFail') {
                        this.globalComponentService.openErrorAlert('連線超時，請重新登入', {
                            afterClose: () => {
                                window.close();
                            }
                        });
                    }
                }
                else if (this.type === TemplateType.subject) { // 主題頁
                    if (dataFromParent.subjectEdit && dataFromParent.subjectEdit.accessToken) {
                        // 主題編輯
                        sessionStorage.setItem(this.generatorEnv.accessTokenKey, dataFromParent.subjectEdit.accessToken);
                        sessionStorage.setItem(this.generatorEnv.refreshTokenKey, dataFromParent.subjectEdit.refreshToken);
                        this.startReadyToTimeOutTimer(dataFromParent.subjectEdit.accessToken, dataFromParent.subjectEdit.refreshToken);
                        subj.next(dataFromParent.subjectEdit);
                        if (this._isRefreshing.value) {
                            this._isRefreshing.next(false);
                        }
                        else {
                            if (!this.serverConfigService.isEditModeUrl) {
                                this.serverConfigService.isEditModeUrl = true;
                            }
                        }
                    }
                    else if (dataFromParent === 'close') {
                        window.close();
                    }
                    else if (dataFromParent === 'timeoutRefreshFail') {
                        this.globalComponentService.openErrorAlert('連線超時，請重新登入', {
                            afterClose: () => {
                                window.close();
                            }
                        });
                    }
                }
                else { // 未定意的位址
                    console.error('未匹配路由的網址');
                }
            }
        }, false);
        return subj;
    }
    /** 註冊模板服務實例 */
    registTemplateService(service, type) {
        if (type === this.type) {
            this.templateService = service;
            service._errorHandler = this._errorHandler;
        }
    }
    startReadyToTimeOutTimer(accessToken, refreshToken) {
        this.lastedActiveTimeStamp = new Date().getTime();
        if (this.timeoutAlertTimerSubc) {
            this.timeoutAlertTimerSubc.unsubscribe();
            delete this.timeoutAlertTimerSubc;
        }
        if (this.timeoutAlert2TimerSubc) {
            this.timeoutAlert2TimerSubc.unsubscribe();
            delete this.timeoutAlert2TimerSubc;
        }
        if (this.timeoutTimerSubc) {
            this.timeoutTimerSubc.unsubscribe();
            delete this.timeoutTimerSubc;
        }
        const jwtPayload = parseJWTtoken(accessToken);
        const iatTime = jwtPayload['iat'] * 1000;
        const expTime = jwtPayload['exp'] * 1000;
        const jwtPayload2 = parseJWTtoken(refreshToken);
        const refreshExpTime = jwtPayload2['exp'] * 1000;
        // 到期五分鐘後還有操作畫面要自動更新token
        let alertTime = expTime + 5 * 60 * 1000;
        if (refreshExpTime - expTime > 2 * 60 * 1000) {
            // accessToken 和 refreshToken 的到期時間差必須超過 2 分鐘，不然無法等到超時候才去判斷最後行為需不需要重刷連線
            if (alertTime > (refreshExpTime - 60000)) {
                alertTime = (expTime + refreshExpTime) / 2;
            }
        }
        else {
            alertTime = expTime;
        }
        let alertTimeDiff = alertTime - new Date().getTime();
        if (alertTimeDiff > 0) {
            this.timeoutAlertTimerSubc = timer(alertTimeDiff)
                .subscribe(timeStamp => {
                // 最後的操作在連線有效時間前五分鐘以前
                if (moment(this.lastedActiveTimeStamp).isBefore(moment(expTime - 10 * 60 * 1000))) {
                    this.globalComponentService.openSanckBar('還在編輯嗎? 別忘了存檔喔!');
                }
                else { // 最後的操作在連線有效時間前五分鐘以內就自動更新 token
                    this.requestUpdateToken();
                }
            });
        }
        // refreshToken 到期前一分鐘決定要不要更新連線，或強烈提醒第二次
        const alertTime2 = refreshExpTime - 60000;
        const timeOutAlert2Diff = alertTime2 - new Date().getTime();
        if (timeOutAlert2Diff > 0) {
            this.timeoutAlert2TimerSubc = timer(timeOutAlert2Diff)
                .subscribe(timeStamp => {
                // 最後的操作在連線有效時間前五分鐘以前
                if (moment(this.lastedActiveTimeStamp).isBefore(moment(expTime - 10 * 60 * 1000))) {
                    // this.globalComponentService.openSanckBar('連線已斷開，您已經太久沒操作畫面。<br>請重新開啟編輯頁面');
                    this.globalComponentService.openInfoAlert('連線將於 1 分鐘內到期，請盡速存檔!');
                }
                else { // 最後的操作在連線有效時間前五分鐘以內就自動更新 token
                    this.requestUpdateToken();
                }
            });
        }
        // refreshToken 到期後彈出提醒請他關掉視窗
        const untilExpTimeDiff = refreshExpTime - new Date().getTime();
        if (untilExpTimeDiff > 0) {
            this.timeoutTimerSubc = timer(untilExpTimeDiff)
                .subscribe(timeStamp => {
                // 最後的操作在連線有效時間前五分鐘以前
                if (moment(this.lastedActiveTimeStamp).isBefore(moment(expTime - 10 * 60 * 1000))) {
                    this.globalComponentService.globalCmp['infoAlert'].infoConfirm.close();
                    this.globalComponentService.openInfoAlert('連線已斷開，您已經太久沒操作畫面。<br>請重新開啟編輯頁面');
                }
                else { // 最後的操作在連線有效時間前五分鐘以內就自動更新 token
                    this.requestUpdateToken();
                }
            });
        }
    }
    /** 要求維持連線 */
    keepConnection() {
        this.lastedActiveTimeStamp = new Date().getTime();
    }
    /** 要求更新存取權杖 */
    requestUpdateToken() {
        const stageUrl = decodeURIComponent(atob(decodeURIComponent(this.route.snapshot.queryParams['stage'])));
        window.opener.postMessage('timeoutRefresh', stageUrl);
    }
}
BackStageTemplateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BackStageTemplateService_Factory() { return new BackStageTemplateService(i0.ɵɵinject(i1.GENERATOR_ENV_TOKEN), i0.ɵɵinject(i2.ActivatedRoute), i0.ɵɵinject(i3.GlobalComponentService), i0.ɵɵinject(i4.TranslateService), i0.ɵɵinject(i5.ServerConfigService)); }, token: BackStageTemplateService, providedIn: "root" });
